module.exports = __webpack_public_path__ + "static/splatoon-b-05fd2b4ab5f60a1e21add2cc2920f5d4.png";